<template>
  <div>
    <div class="top_bar_ clearfix_">
      <div class="w1000_">
        <div v-if="!isLogined" class="left_ f_l_">
          欢迎登录{{ storeName }}，请
          <span class="c11_">
            <router-link class="c11_" :to="{ name: 'login' }">登录</router-link>
            <router-link class="c11_" :to="{ name: 'register' }"
              >/免费注册</router-link
            >
          </span>
        </div>
        <div v-else class="left_ f_l_">
          <span @click="loginOut()" style="cursor:pointer">退出登录</span>
        </div>
        <div class="right_ f_r_">
          <a class="mrg_r36_"
            ><router-link :to="{ name: 'home' }">首页</router-link></a
          >
          <!-- <a class="mrg_r36_" style=" margin-left:30px;"><router-link :to="{name: 'aboutUs'}">公司介绍</router-link></a>
                    <a class="mrg_r36_" style=" margin-left:30px;"><router-link :to="{name: 'claimsGuide'}">理赔指引</router-link></a> 
                    <a class="vline_" style=" margin-left:30px;"> <router-link :to="{name: 'commonQuestion'}">常见问题</router-link></a>
                    <a class="javascript:void(0)"><router-link  :to="{name: 'contactUs'}">联系我们</router-link></a> -->
          <a
            class="mrg_r36_"
            style=" margin-left:30px;"
            href="https://www.starrchina.cn/Contact-Us/"
            target="_blank"
            >联系我们</a
          >
          <a
            class="mrg_r36_"
            style=" margin-left:30px;"
            href="https://www.starrchina.cn/Careers/"
            target="_blank"
            >人才招聘</a
          >
          <a
            class="mrg_r36_"
            href="https://www.starrchina.cn/Policy%20Query/"
            target="_blank"
            style=" margin-left:30px;"
            >保单查询</a
          >
          <a
            class="mrg_r36_"
            style=" margin-left:30px;"
            href="https://application.starrchina.cn:9080/fr/my001.homeInit.ac"
            target="_blank"
            >在线理赔</a
          >
          <a
            class="mrg_r36_"
            style=" margin-left:30px;"
            href="https://www.starrchina.cn/WhoWeAre/"
            target="_blank"
            >关于我们</a
          >
          <a
            class="mrg_r36_"
            style=" margin-left:30px;"
            href="https://www.starrchina.cn/MyFavorites/"
            target="_blank"
            >我的收藏</a
          >
          <a
            class="mrg_r36_"
            style=" margin-left:30px;"
            href="https://www.starrchina.cn/Information%20Disclosure/"
            target="_blank"
            >信息披露</a
          >
          <a href="javascript:void(0)" style=" margin-left:30px;"
            >本网站支持IPV6</a
          >
        </div>
      </div>
    </div>
    <div class="top1_ w1000_" v-if="navshow === true">
      <div class="f_l_">
        <img class="logo_" :src="logoUrl" />
        <a
          href="https://www.starrchina.cn/Information%20Disclosure/"
          target="_blank"
          >信息披露</a
        >
        <a href="https://www.starrchina.cn/Insurance/" target="_blank"
          >保险介绍</a
        >
        <a href="http://pc-store.starrchina.cn/pcmall/" target="_blank"
          >保险商城</a
        >
        <a
          href="https://starr.tmall.com/shop/view_shop.htm?tbpm=1"
          target="_blank"
          >天猫旗舰店</a
        >
        <a href="https://www.starrchina.cn/RiskTips/" target="_blank"
          >保险消费风险提示</a
        >
        <a href="https://www.starrchina.cn/News/StarrInTheNews/" target="_blank"
          >新闻</a
        >
        <a href="https://www.starrchina.cn/senior%20citizen/">老人专线</a>
      </div>
      <div class="f_r_">
        <div class="item_ c11_" @click="getSetting()" style="cursor:pointer">
          <i class="i_icon_ i_order_"></i>
          <div>服务中心</div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.top_bar_ {
  background: #001d3b;
  color: #fff;
  font-size: 12px;
  line-height: 33px;
  .left_ {
    white-space: nowrap;
  }
  .vline_ {
    &::after {
      display: inline-block;
      vertical-align: middle;
      content: "";
      width: 1px;
      height: 13px;
      background: #fff;
      margin: 0px 18px;
      margin-top: -1px;
    }
  }
  a {
    color: #fff;
  }
}
.top1_ {
  white-space: nowrap;
  display: flex;
  justify-content: space-between;
  align-items: center;
  img {
    width: 159px;
    height: 72px;
    margin: 13px 0 15px 73px;
    object-fit: cover;
  }
  .search_wrap_ {
    position: relative;
    display: inline-block;
    margin: auto 69px auto 95px;

    .input_search_ {
      width: 258px;
      height: 42px;
      border-radius: 0;
    }
    .btn_search_ {
      width: 88px;
      height: 42px;
      border-radius: 0;
      box-shadow: none;
    }
    .keyword_list_ {
      position: absolute;
      left: 0px;
      right: 88px;
      top: 100%;
      z-index: 666;
      line-height: 28px;
      border: 1px solid #f5692c;
      border-top: none;
      min-height: 200px;
      max-height: 300px;
      overflow-y: auto;
      background: #fff;
      font-size: 16px;
      li {
        padding-left: 20px;
        cursor: pointer;
        &:hover {
          background: #f5692c;
          color: #fff;
        }
      }
    }
  }
  .f_r_ {
    display: flex;
    align-items: center;
    vertical-align: middle;
    margin: 13px 0 15px 0;
    color: #ff4c1c;
  }
  .f_l_ {
    display: flex;
    align-items: center;
    .logo_ {
      margin-left: 0;
    }
    a {
      margin-left: 30px;
      font-size: 17px;
    }
  }
  .item_ {
    display: inline-block;
    .i_icon_ {
      display: block;
      width: 16px;
      height: 17px;
      margin: 0 auto 8px;
      &.i_service_ {
        background: url("../../../assets/wxmall/4.png") no-repeat;
        background-size: 100% auto;
      }
      &.i_order_ {
        background: url("../../../assets/wxmall/5.png") no-repeat;
        background-size: 100% auto;
      }
      &.i_product_ {
        background: url("../../../assets/wxmall/6.png") no-repeat;
        background-size: 100% auto;
      }
    }
  }
  .vline_ {
    display: inline-block;
    vertical-align: middle;
    &::after {
      display: inline-block;
      content: "";
      width: 1px;
      height: 26px;
      background: rgba(0, 0, 0, 0.1);
      margin: auto 25px;
    }
  }
}
</style>
<script>
import Storage from "@/utils/storage";
import { getToken, setToken, setLogined } from "@/utils/authorized";
import api from "@/utils/api";
const KEY = "_history_search_keyword";

export default {
  props: {
    flag: {
      type: Number
    }
  },
  data() {
    return {
      showKeywordList: false,
      keywordList: [],
      keyword: "",
      isLogined: getToken() ? true : false,
      logoUrl: "",
      servicePhone: "",
      storeName: "",
      introduceUrl: "",
      myArray: [],
      navshow: true
    };
  },
  mounted() {
    this.fetchData();
    if (this.flag === 0) {
      this.navshow = false;
    }
  },
  methods: {
    fetchData() {
      let userId = 771596; //后台配置用户:GDSC01 GDsc01-01
      if (window.location.href.indexOf("run4wd") > -1) {
        userId = 590584;
      }
      api
        .queryStore({
          userId: userId
        })
        .then(res => res.data)
        .then(data => {
          if (data.returnCode === "00" && data.content != "") {
            this.logoUrl = data.content.coreStoreDto.logoUrl;
            this.servicePhone = data.content.coreStoreDto.servicePhone;
            this.storeName = data.content.coreStoreDto.storeName;
          }
        });
      api
        .getCorePcstore()
        .then(res => res.data)
        .then(data => {
          if (data.returnCode === "0000" && data.data != "") {
            this.introduceUrl = data.data.companyIntroduceUrl;
          }
        });
    },
    handleSearch(item) {
      console.log("item -> ", item);
      this.keyword = item;
      // this.$emit('search', this.keyword)
    },
    onSearchBlur() {
      let st = setTimeout(() => {
        this.showKeywordList = false;
        clearTimeout(st);
      }, 300);
    },
    onSearchChange(e) {
      console.log("onSearchChange -> ", e);
      // if (!this.showKeywordList) {
      this.keywordList = Storage.get(KEY);
      this.showKeywordList = true;
      // }
      console.log(this.keywordList, Storage.get(KEY), 1);
    },
    onSearch() {
      const keyword = this.keyword;
      console.log("onSearch -> ", keyword);
      const arr = Storage.addItem(KEY, keyword);
      this._productName = keyword;
      this.$emit("search", keyword);
      console.log(Storage.get(KEY), "保存的搜索数据");
    },
    godetail() {
      console.log(getToken(), "getToken()");
      if (getToken()) {
        let routeUrl = this.$router.resolve({
          path: "/sd",
          query: { sign: getToken() }
        });
        window.open(routeUrl.href, "_blank");
      } else {
        var num = Math.ceil(Math.random() * 10);
        window.router.push({ name: "login", params: { num } });
      }
    },
    loginOut() {
      api
        .logout()
        .then(res => res.data)
        .then(data => {
          setToken("");
          setLogined(0);
          var num = Math.ceil(Math.random() * 10);
          window.router.push({ name: "login", params: { num } });
        });
    },
    getSetting() {
      //    2367
      api.queryNavBar().then(res => {
        if (res.data.returnCode === "0000" || res.data.content != null) {
          res.data.content.map(item => {
            this.myArray.push(item.id);
          });
          if (this.myArray.length > 0) {
            console.log("------");
            if (this.myArray.indexOf(2) > -1) {
              this.$router.push({
                name: "ordered"
              });
            } else if (this.myArray.indexOf(3) > -1) {
              this.$router.push({
                name: "surrender"
              });
            } else if (this.myArray.indexOf(6) > -1) {
              this.$router.push({
                name: "manage"
              });
            } else if (this.myArray.indexOf(7) > -1) {
              this.$router.push({
                name: "query"
              });
            }
          }
        }
      });
    }
  }
};
</script>
